import { useState, useEffect } from "react";
import { fileService } from "@/services/breeze/FileService";

/**
 * Simple hook for loading image thumbnails
 */
export function useThumbnail(
  file: {
    id: number;
    file_type: string;
    is_public?: boolean;
    cdn_url?: string;
    anythink_url?: string;
  } | null,
) {
  const [blobUrl, setBlobUrl] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!file?.file_type?.startsWith("image/")) {
      setBlobUrl(null);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);

    let cancelled = false;
    const loadThumbnail = async () => {
      try {
        let url: string | null = null;

        if (file.is_public && file.cdn_url) {
          url = file.cdn_url;
        } else if (file.anythink_url) {
          url = await fileService.getFileSignedUrl(file.id);
        }

        if (cancelled) return;
        if (!url) {
          setError("No thumbnail data");
          return;
        }

        setBlobUrl(url);
      } catch {
        if (!cancelled) setError("Failed to load");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    loadThumbnail();

    return () => {
      cancelled = true;
    };
  }, [
    file?.id,
    file?.anythink_url,
    file?.cdn_url,
    file?.file_type,
    file?.is_public,
  ]);

  return { blobUrl, loading, error };
}
